<script>
  import { selectedLanguage } from "../etc/store.js"
</script>

{#if $selectedLanguage == "TW"}
  <main>
    <div class="xicu2 show-book">
      <h5>【繫辭 下】</h5>
      <p>
        八卦成列，象在其中矣；因而重之，爻在其中矣；剛柔相推，變在其中矣；繫辭焉而命之，動在其中矣。
        吉凶悔吝者，生乎動者也；剛柔者，立本者也；變通者，趣時者也；
        吉凶者，貞勝者也；天地之道，貞觀者也；日月之道，貞明者也；天下之動，貞夫一者也。
        夫乾，確然示人易矣；夫坤，隤然示人簡矣。爻也者，效此者也；象也者，像此者也。
        爻象動乎內，吉凶見乎外，功業見乎變，聖人之情見乎辭。
        天地之大德曰生，聖人之大寶曰位。何以守位？曰仁；何以聚人，曰財？理財正辭，禁民為非，曰義。
      </p>
      <p>
        古者包犧氏之王天下也，仰則觀象於天，俯則觀法於地，觀鳥獸之文，與地之宜，近取諸身，遠取諸物，於是始作八卦，以通神明之德，以類萬物之情。
        作結繩而為罔罟，以佃以漁，蓋取諸「離」。
        包犧氏沒，神農氏作。斲木為耜，揉木為耒，耒耨之利，以教天下，蓋取諸「益」。
        日中為市，致天下之民，聚天下之貨，交易而退，各得其所，蓋取諸「噬嗑」。
        神農氏沒，黃帝、堯、舜氏作，通其變，使民不倦；神而化之，使民宜之。
        易，窮則變，變則通，通則久，是以「自天祐之，吉，无不利」。
        黃帝、堯、舜，垂衣裳而天下治，蓋取諸「乾」「坤」。
        刳木為舟，剡木為楫，舟楫之利，以濟不通，致遠以利天下，蓋取諸「渙」。
        服牛乘馬，引重致遠，以利天下，蓋取諸「隨」。重門擊柝，以待暴客，蓋取諸「豫」。
        斷木為杵，掘地為臼，臼杵之利，萬民以濟，蓋取諸「小過」。
        弦木為弧，剡木為矢，弧矢之利，以威天下，蓋取諸「睽」。
        上古穴居而野處，後世聖人易之以宮室，上棟下宇，以待風雨，蓋取諸「大壯」。
        古之葬者，厚衣之以薪，葬之中野，不封不樹，喪期无數，後世聖人易之以棺槨，蓋取諸「大過」。
        上古結繩而治，後世聖人易之以書契，百官以治，萬民以察，蓋取諸「夬」。
      </p>
      <p>
        是故，易者，象也；象也者，像也。彖者，材也；爻也者，效天下之動者也。
        是故，吉凶生而悔吝著也。
      </p>
      <p>
        陽卦多陰，陰卦多陽，其故何也？
        陽卦奇，陰卦耦。其德行何也？陽一君而二民，君子之道也；陰二君而一民，小人之道也。
      </p>
      <p>
        易曰：「憧憧往來，朋從爾思。」子曰：「天下何思何慮？天下同歸而殊塗，一致而百慮。天下何思何慮？
        日往則月來，月往則日來，日月相推而明生焉。寒往則暑來，暑往則寒來，寒暑相推而歲成焉。
        往者，屈也；來者，信也；屈信相感而利生焉。
        尺蠖之屈，以求信也。龍蛇之蟄，以存身也。精義入神，以致用也。利用安身，以崇德也。
        過此以往，未之或知也。窮神知化，德之盛也。」
        易曰：「困于石，據于蒺蔾，入于其宮，不見其妻，凶。」
        子曰：「非所困而困焉，名必辱；非所據而據焉，身必危。既辱且危，死期將至，妻其可得見耶？」
        易曰：「公用射隼于高墉之上，獲之，无不利。」
        子曰：「隼者，禽也；弓矢者，器也；射之者，人也。
        君子藏器於身，待時而動，何不利之有？動而不括，是以出而有獲，語成器而動者也。」
        子曰：「小人不恥不仁，不畏不義，不見利不勸。不威不懲，小懲而大誡，此小人之福也。
        易曰：『履校滅趾，无咎』，此之謂也。
        善不積，不足以成名；惡不積，不足以滅身。小人以小善為无益，而弗為也；
        以小惡為无傷，而弗去也，故惡積而不可揜，罪大而不可解。易曰：『何校滅耳，凶。』」
        子曰：「危者，安其位者也；亡者，保其存者也；亂者，有其治者也。
        是故，君子安而不忘危，存而不忘亡，治而不忘亂。是以身安而國家可保也。易曰：『其亡其亡，繫于苞桑。』」
        子曰：「德薄而位尊，知小而謀大，力小而任重，鮮不及矣。易曰：『鼎折足，覆公餗，其形渥，凶。』言不勝其任也。」
        子曰：「知幾其神乎！君子上交不諂，下交不瀆。其知幾乎！幾者，動之微，吉之先見者也。君子見幾而作，不俟終日。易曰：『介于石，不終日，貞吉。』介如石焉，寧用終日，斷可識矣。
        君子知微知彰，知柔知剛，萬夫之望。」
        子曰：「顏氏之子，其殆庶幾乎！有不善，未嘗不知；知之，未嘗復行也。易曰：『不遠復，无祇悔，元吉。』
        「天地絪縕，萬物化醇，男女構精，萬物化生。易曰：『三人行，則損一人，一人行，則得其友。』言致一也。」
        子曰：「君子安其身而後動，易其心而後語，定其交而後求。君子脩此三者，故全也。
        危以動，則民不與也；懼以語，則民不應也；无交而求，則民不與也；莫之與，則傷之者至矣。易曰：『莫益之，或擊之，立心勿恆，凶。』
      </p>
      <p>
        子曰：「乾、坤，其易之門邪！乾，陽物也；坤，陰物也。陰陽合德，而剛柔有體，以體天地之撰，以通神明之德。
        其稱名也，雜而不越，於稽其類，其衰世之意邪？
        夫易，彰往而察來，而微顯闡幽，開而當名辨物，正言斷辭，則備矣。
        其稱名也小，其取類也大。其旨遠，其辭文，其言曲而中，其事肆而隱。因貳以濟民行，以明失得之報。」
      </p>
      <p>
        易之興也，其於中古乎？作易者，其有憂患乎？
        是故，「履」，德之基也；「謙」，德之柄也；「復」，德之本也；「恒」，德之固也；
        「損」，德之脩也；「益」，德之裕也；「困」，德之辨也；「井」，德之地也；
        「巽」，德之制也。
        「履」，和而至；「謙」，尊而光；「復」，小而辨於物；「恒」，雜而不厭；「損」，先難而後易；
        「益」，長裕而不設；「困」，窮而通；「井」，居其所而遷；「巽」，稱而隱。
        「履」以和行，「謙」以制禮，「復」以自知，「恒」以一德，「損」以遠害，「益」以興利，
        「困」以寡怨，「井」以辨義，「巽」以行權。
      </p>
      <p>
        易之為書也不可遠，為道也屢遷，變動不居，周流六虛，上下无常，剛柔相易，不可為典要，唯變所適。
        其出入以度，外內使知懼。又明於憂患與故，无有師保，如臨父母。
        初率其辭，而揆其方，既有典常，苟非其人，道不虛行。
      </p>
      <p>
        易之為書也，原始要終，以為質也。六爻相雜，唯其時物也。其初難知，其上易知，本末也。
        初辭擬之，卒成之終。 若夫雜物撰德，辨是與非，則非其中爻不備。
        噫！亦要存亡吉凶，則居可知矣。知者觀其彖辭，則思過半矣。
        二與四同功而異位，其善不同。二多譽，四多懼，近也。柔之為道，不利遠者，其要无咎，其用柔中也。
        三與五同功而異位。三多凶，五多功，貴賤之等也。其柔危，其剛勝邪？
      </p>
      <p>
        易之為書也，廣大悉備，有天道焉，有人道焉，有地道焉。兼三材而兩之，故六。六者，非它也，三材之道也。
        道有變動，故曰爻； 爻有等，故曰物；物相雜，故曰文；文不當，故吉凶生焉。
      </p>
      <p>
        易之興也，其當殷之末世，周之盛德邪？當文王與紂之事邪？是故其辭危。
        危者使平，易者使傾，其道甚大，百物不廢。懼以終始，其要无咎，此之謂易之道也。
      </p>
      <p>
        夫乾，天下之至健也，德行恒易以知險；夫坤，天下之至順也，德行恒簡以知阻。
        能說諸心，能研諸侯之慮，定天下之吉凶，成天下之亹亹者。
        是故，變化云為，吉事有祥；象事知器，占事知來。
        天地設位，聖人成能，人謀鬼謀，百姓與能。
        八卦以象告，爻彖以情言，剛柔雜居而吉凶可見矣。
        變動以利言，吉凶以情遷，是故愛惡相攻而吉凶生，遠近相取而悔吝生，情偽相感而利害生。
        凡易之情，近而不相得，則凶。或害之，悔且吝。
        將叛者其辭慚，中心疑者其辭枝，吉人之辭寡，躁人之辭多，誣善之人其辭游，失其守者其辭屈。
      </p>
    </div>
  </main>
{:else}
  <main>
    <div class="xicu2 show-book">
      <h5>【系辞 下】</h5>
      <p>
        八卦成列，象在其中矣；因而重之，爻在其中矣；刚柔相推，变在其中矣；系辞焉而命之，动在其中矣。
        吉凶悔吝者，生乎动者也；刚柔者，立本者也；变通者，趣时者也；
        吉凶者，贞胜者也；天地之道，贞观者也；日月之道，贞明者也；天下之动，贞夫一者也。
        夫乾，确然示人易矣；夫坤，隤然示人简矣。爻也者，效此者也；象也者，像此者也。
        爻象动乎内，吉凶见乎外，功业见乎变，圣人之情见乎辞。
        天地之大德曰生，圣人之大宝曰位。何以守位？曰仁；何以聚人，曰财？理财正辞，禁民为非，曰义。
      </p>
      <p>
        古者包牺氏之王天下也，仰则观象于天，俯则观法于地，观鸟兽之文，与地之宜，近取诸身，远取诸物，于是始作八卦，以通神明之德，以类万物之情。
        作结绳而为罔罟，以佃以渔，盖取诸「离」。
        包牺氏没，神农氏作。斲木为耜，揉木为耒，耒耨之利，以教天下，盖取诸「益」。
        日中为市，致天下之民，聚天下之货，交易而退，各得其所，盖取诸「噬嗑」。
        神农氏没，黄帝、尧、舜氏作，通其变，使民不倦；神而化之，使民宜之。
        易，穷则变，变则通，通则久，是以「自天祐之，吉，无不利」。
        黄帝、尧、舜，垂衣裳而天下治，盖取诸「乾」「坤」。
        刳木为舟，剡木为楫，舟楫之利，以济不通，致远以利天下，盖取诸「涣」。
        服牛乘马，引重致远，以利天下，盖取诸「随」。重门击柝，以待暴客，盖取诸「豫」。
        断木为杵，掘地为臼，臼杵之利，万民以济，盖取诸「小过」。
        弦木为弧，剡木为矢，弧矢之利，以威天下，盖取诸「睽」。
        上古穴居而野处，后世圣人易之以宫室，上栋下宇，以待风雨，盖取诸「大壮」。
        古之葬者，厚衣之以薪，葬之中野，不封不树，丧期无数，后世圣人易之以棺椁，盖取诸「大过」。
        上古结绳而治，后世圣人易之以书契，百官以治，万民以察，盖取诸「夬」。
      </p>
      <p>
        是故，易者，象也；象也者，像也。彖者，材也；爻也者，效天下之动者也。
        是故，吉凶生而悔吝著也。
      </p>
      <p>
        阳卦多阴，阴卦多阳，其故何也？
        阳卦奇，阴卦耦。其德行何也？阳一君而二民，君子之道也；阴二君而一民，小人之道也。
      </p>
      <p>
        易曰：「憧憧往来，朋从尔思。」子曰：「天下何思何虑？天下同归而殊涂，一致而百虑。天下何思何虑？
        日往则月来，月往则日来，日月相推而明生焉。寒往则暑来，暑往则寒来，寒暑相推而岁成焉。
        往者，屈也；来者，信也；屈信相感而利生焉。
        尺蠖之屈，以求信也。龙蛇之蛰，以存身也。精义入神，以致用也。利用安身，以崇德也。
        过此以往，未之或知也。穷神知化，德之盛也。」
        易曰：「困于石，据于蒺蔾，入于其宫，不见其妻，凶。」
        子曰：「非所困而困焉，名必辱；非所据而据焉，身必危。既辱且危，死期将至，妻其可得见耶？」
        易曰：「公用射隼于高墉之上，获之，无不利。」
        子曰：「隼者，禽也；弓矢者，器也；射之者，人也。
        君子藏器于身，待时而动，何不利之有？动而不括，是以出而有获，语成器而动者也。」
        子曰：「小人不耻不仁，不畏不义，不见利不劝。不威不惩，小惩而大诫，此小人之福也。
        易曰：『履校灭趾，无咎』，此之谓也。
        善不积，不足以成名；恶不积，不足以灭身。小人以小善为无益，而弗为也；
        以小恶为无伤，而弗去也，故恶积而不可揜，罪大而不可解。易曰：『何校灭耳，凶。』」
        子曰：「危者，安其位者也；亡者，保其存者也；乱者，有其治者也。
        是故，君子安而不忘危，存而不忘亡，治而不忘乱。是以身安而国家可保也。易曰：『其亡其亡，系于苞桑。』」
        子曰：「德薄而位尊，知小而谋大，力小而任重，鲜不及矣。易曰：『鼎折足，覆公𫗧，其形渥，凶。』言不胜其任也。」
        子曰：「知几其神乎！君子上交不谄，下交不渎。其知几乎！几者，动之微，吉之先见者也。君子见几而作，不俟终日。易曰：『介于石，不终日，贞吉。』介如石焉，宁用终日，断可识矣。
        君子知微知彰，知柔知刚，万夫之望。」
        子曰：「颜氏之子，其殆庶几乎！有不善，未尝不知；知之，未尝复行也。易曰：『不远复，无祇悔，元吉。』
        「天地絪缊，万物化醇，男女构精，万物化生。易曰：『三人行，则损一人，一人行，则得其友。』言致一也。」
        子曰：「君子安其身而后动，易其心而后语，定其交而后求。君子修此三者，故全也。
        危以动，则民不与也；惧以语，则民不应也；无交而求，则民不与也；莫之与，则伤之者至矣。易曰：『莫益之，或击之，立心勿恒，凶。』
      </p>
      <p>
        子曰：「乾、坤，其易之门邪！乾，阳物也；坤，阴物也。阴阳合德，而刚柔有体，以体天地之撰，以通神明之德。
        其称名也，杂而不越，于稽其类，其衰世之意邪？
        夫易，彰往而察来，而微显阐幽，开而当名辨物，正言断辞，则备矣。
        其称名也小，其取类也大。其旨远，其辞文，其言曲而中，其事肆而隐。因贰以济民行，以明失得之报。」
      </p>
      <p>
        易之兴也，其于中古乎？作易者，其有忧患乎？
        是故，「履」，德之基也；「谦」，德之柄也；「复」，德之本也；「恒」，德之固也；
        「损」，德之修也；「益」，德之裕也；「困」，德之辨也；「井」，德之地也；
        「巽」，德之制也。
        「履」，和而至；「谦」，尊而光；「复」，小而辨于物；「恒」，杂而不厌；「损」，先难而后易；
        「益」，长裕而不设；「困」，穷而通；「井」，居其所而迁；「巽」，称而隐。
        「履」以和行，「谦」以制礼，「复」以自知，「恒」以一德，「损」以远害，「益」以兴利，
        「困」以寡怨，「井」以辨义，「巽」以行权。
      </p>
      <p>
        易之为书也不可远，为道也屡迁，变动不居，周流六虚，上下无常，刚柔相易，不可为典要，唯变所适。
        其出入以度，外内使知惧。又明于忧患与故，无有师保，如临父母。
        初率其辞，而揆其方，既有典常，苟非其人，道不虚行。
      </p>
      <p>
        易之为书也，原始要终，以为质也。六爻相杂，唯其时物也。其初难知，其上易知，本末也。
        初辞拟之，卒成之终。 若夫杂物撰德，辨是与非，则非其中爻不备。
        噫！亦要存亡吉凶，则居可知矣。知者观其彖辞，则思过半矣。
        二与四同功而异位，其善不同。二多誉，四多惧，近也。柔之为道，不利远者，其要无咎，其用柔中也。
        三与五同功而异位。三多凶，五多功，贵贱之等也。其柔危，其刚胜邪？
      </p>
      <p>
        易之为书也，广大悉备，有天道焉，有人道焉，有地道焉。兼三材而两之，故六。六者，非它也，三材之道也。
        道有变动，故曰爻； 爻有等，故曰物；物相杂，故曰文；文不当，故吉凶生焉。
      </p>
      <p>
        易之兴也，其当殷之末世，周之盛德邪？当文王与纣之事邪？是故其辞危。
        危者使平，易者使倾，其道甚大，百物不废。惧以终始，其要无咎，此之谓易之道也。
      </p>
      <p>
        夫乾，天下之至健也，德行恒易以知险；夫坤，天下之至顺也，德行恒简以知阻。
        能说诸心，能研诸侯之虑，定天下之吉凶，成天下之亹亹者。
        是故，变化云为，吉事有祥；象事知器，占事知来。
        天地设位，圣人成能，人谋鬼谋，百姓与能。
        八卦以象告，爻彖以情言，刚柔杂居而吉凶可见矣。
        变动以利言，吉凶以情迁，是故爱恶相攻而吉凶生，远近相取而悔吝生，情伪相感而利害生。
        凡易之情，近而不相得，则凶。或害之，悔且吝。
        将叛者其辞惭，中心疑者其辞枝，吉人之辞寡，躁人之辞多，诬善之人其辞游，失其守者其辞屈。
      </p>
    </div>
  </main>
{/if}

<style>
  .show-book {
    /* height: 400px; */
    font-size: 20px;
    font-weight: 300;
    padding-left: 20px;
    padding-right: 20px;
    margin-right: 10px;
    /* background-color: #eeeeff; */
    overflow-y: auto;
  }
</style>
